module.exports = __webpack_public_path__ + "static/media/paintless-dent-repair.c3c03885.jpg";